import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { throwOnError } from 'api/helpers';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

async function getB2CVerificationsRequestQuery(
  apiClient: ApiClient,
  filter: { searchString?: string; page?: number; itemsPerPage?: number; status?: string; user_id?: number },
) {
  return apiClient.GET(`/op/v2/b2c-verification`, { params: { query: filter } });
}

export default function useB2CVerificationsRequestQuery(filter: {
  searchString?: string;
  page?: number;
  itemsPerPage?: number;
  status?: string;
  country?: string;
}) {
  const apiClient = useApiClient();
  const toast = useToast();

  const query = useQuery({
    queryKey: getKey(filter),
    queryFn: () => throwOnError(getB2CVerificationsRequestQuery(apiClient, filter)),
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);
  return query;
}

function getKey(filter: { searchString?: string; page?: number; itemsPerPage?: number; status?: string; user_id?: number }): QueryKey {
  return ['B2CVerificationsRequest', filter];
}

useB2CVerificationsRequestQuery.getKey = getKey;
